var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 27,
    viewBox: "0 0 29.25 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-business",
    "data-name": "Icon ionic-md-business",
    d: "M18.352,10.5v-6H3.375v27h29.25v-21Zm-8.986,18h-3v-3h3Zm0-6h-3v-3h3Zm0-6h-3v-3h3Zm0-6h-3v-3h3Zm5.991,18h-3v-3h3Zm0-6h-3v-3h3Zm0-6h-3v-3h3Zm0-6h-3v-3h3Zm14.273,18H18.352v-3h3v-3h-3v-3h3v-3h-3v-3H29.63Zm-2.644-12h-3v3h3Zm0,6h-3v3h3Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#7c7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessGrey);
export default __webpack_public_path__ + "static/media/icon-business-grey.7554cf00.svg";
export { ForwardRef as ReactComponent };